import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutAddresssComponentDef } from '@df/checkout/checkout-address.component.def';
import { Client } from '@df/core/service/client';
import { IAddressData } from '@df/session/api/address-book/address';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AddressFieldsetComponent } from '../ui/form/address-fieldset/address-fieldset.component';
import { CheckboxComponent } from '../ui/form/checkbox';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio';
import { NCheckoutAddressModal } from './checkout-address-modal/checkout-address-modal.component';

@Component({
    selector: 'checkout-address',
    templateUrl: './checkout-address.html',
    standalone: true,
    imports: [
        AddressFieldsetComponent,
        CheckboxComponent,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        NgStyle,
        RadioComponent,
        RadioGroupDirective,
        SizeClassDirective,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAddresssComponent extends CheckoutAddresssComponentDef {
    private dfModalService = inject(DfModalService);

    protected client = inject(Client);

    protected handlAddressSelect(event: Event, itemData: IAddressData) {
        if (event.defaultPrevented) {
            return;
        }
        this.rewriteAddress(itemData);
    }

    /**
     * rewrite cslected address to shipping
     */
    protected rewriteAddress(itemData: IAddressData) {
        this.data.firstname = itemData.firstname;
        this.data.lastname = itemData.lastname;
        this.data.telephone = itemData.telephone;
        this.data.postcode = itemData.postcode;
        this.data.city = itemData.city;
        this.data.region = itemData.region;
        this.data.street_1 = itemData.street_1;
        this.data.street_2 = itemData.street_2;
        this.detectChanges();
    }
    /**
     * reset address
     */
    protected resetAddress() {
        this.data.firstname = undefined;
        this.data.lastname = undefined;
        this.data.telephone = undefined;
        this.data.postcode = undefined;
        this.data.city = undefined;
        this.data.region = undefined;
        this.data.street_1 = undefined;
        this.data.street_2 = undefined;
        this.detectChanges();
    }

    protected emptyData() {
        return {
            firstname: '',
            lastname: '',
            telephone: '',
            postcode: '',
            city: '',
            region: '',
            street_1: '',
            street_2: ''
        };
    }

    protected onSaveAddress() {
        if (this.isBilling) {
            this.checkoutFormComponent.saveBillingAddress();
        } else {
            this.checkoutFormComponent.saveShippingAddress();
        }
    }

    protected handleEditAddress(event: Event, data: IAddressData) {
        event.preventDefault();
        const dataCopy = { ...data };
        this.dfModalService.open(undefined, NCheckoutAddressModal.componentId, undefined, {
            addressData: dataCopy,
            onSaveAddress: async () => {
                const addressId = dataCopy.id;
                if (this.checkoutFormComponent.data.address.shipping?.customer_address_id === addressId) {
                    await this.checkoutFormComponent.saveShippingAddress();
                    this.rewriteAddress(dataCopy);
                } else if (this.checkoutFormComponent.data.address?.billing.customer_address_id === addressId) {
                    await this.checkoutFormComponent.saveBillingAddress();
                }
                this.detectChanges();
            }
        });
    }
}
